/** @jsxImportSource theme-ui @jsxRuntime classic */
import { H } from '@hzdg/sectioning';
import * as Icons from '@tishman/icons';
import React from 'react';

import * as colors from './themes/colors';

import { Grid, Box, Text, Container, useBreakpointIndex } from '.';

export interface TicketInfoProps {
  items?: TicketInfoItemProps[];
}

export interface TicketInfoItemProps {
  title?: string;
  copy?: string;
  icon?: string;
}

export const TicketInfo = ({ items }: TicketInfoProps): JSX.Element => {
  const isMobile = useBreakpointIndex() < 2;

  const getIcon = (icon: string) => {
    switch (icon) {
      case 'time':
        return (
          <Icons.Time
            aria-hidden="true"
            style={{
              color: colors.BLACK,
              maxWidth: isMobile ? '48px' : 'unset',
            }}
          />
        );
      case 'umbrella':
        return (
          <Icons.Umbrella
            aria-hidden="true"
            style={{
              color: colors.BLACK,
              maxWidth: isMobile ? '48px' : 'unset',
            }}
          />
        );
      case 'issue':
        return (
          <Icons.ReIssue
            aria-hidden="true"
            style={{
              color: colors.BLACK,
              maxWidth: isMobile ? '48px' : 'unset',
            }}
          />
        );
      case 'hidden':
        return (
          <Icons.HiddenFees
            aria-hidden="true"
            style={{
              color: colors.BLACK,
              maxWidth: isMobile ? '48px' : 'unset',
            }}
          />
        );
    }
  };

  return (
    <Container
      data-module="TicketInfo"
      sx={{ pb: [4, 7], pt: [0, 4], px: [3, 5], bg: colors.WHITE }}
    >
      <Grid
        sx={{
          gridGap: 5,
          gridTemplateColumns: [
            'repeat(1, 1fr)',
            'repeat(2, 1fr)',
            'repeat(3, 1fr)',
          ],
        }}
      >
        {items?.map(({ title, copy, icon = '' }) => (
          <Box key={title} sx={{ textAlign: 'left' }}>
            {getIcon(icon)}
            <H
              sx={{
                variant: 'styles.h3',
                fontSize: 5,
                fontFamily: 'headingSecondary',
                mb: [3, 0],
                mt: 3,
                color: colors.BLACK,
              }}
            >
              {title}
            </H>
            <Text sx={{ color: colors.BLACK }}>{copy}</Text>
          </Box>
        ))}
      </Grid>
    </Container>
  );
};
